import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

interface ComponentData {
  idComponent: string;
  isLoading: boolean;
}

class QwLoadingManager {
  private status$ = new BehaviorSubject<Record<string, boolean>>({});

  public loadComplete$ = this.status$.pipe(
    distinctUntilChanged((prev, current) => {
      return JSON.stringify(prev) === JSON.stringify(current);
    }),
    map((status) => {
      return Object.values(status).every((value) => {
        return value === false;
      });
    }),
    distinctUntilChanged(),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  setLoading(data: ComponentData) {
    const currentValue = this.status$.value;
    const nextValue = { ...currentValue, [data.idComponent]: data.isLoading };
    this.status$.next(nextValue);
  }
}

export const loadingService = new QwLoadingManager();
